import api from './api';

export const getCsrfToken = async () => {
  await api.get('/csrf-cookie');

  const xsrfToken = decodeURIComponent(
    document.cookie
      .split('; ')
      .find((row) => row.startsWith('XSRF-TOKEN='))
      ?.split('=')[1] || ''
  );

  api.defaults.headers.common['X-XSRF-TOKEN'] = xsrfToken;
};
